import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { Routes } from '@angular/router';

export const appRoutes: Routes = [
    {
        path: 'login',
        redirectTo: 'seasonal-app/login',
    },
    {
        path: 'seasonal-app',
        //./app/modules/staff-app/staff-app.module#StaffAppModule
        loadChildren: () => import('./modules/staff-app/staff-app.module').then(m => m.StaffAppModule),
        runGuardsAndResolvers: 'always',
        data: { preload: false } // Custom property we will use to track what route to be preloaded
    },
    {
        path: '',
        component: NotFoundComponent
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];
